<template>
  <div class="medicine-edit-page w-100">
    <!-- Header Section -->
    <div class="w-100 px-8 py-4 bg-white border-bottom">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <b-button variant="light" class="mr-4 btn btn-secondary" @click="goBack">
            <i class="ki ki-arrow-left icon-sm"></i>
            Quay lại
          </b-button>
        </div>
        <div>
          <b-button variant="secondary" class="mr-2" @click="goBack">
            Hủy
          </b-button>
          <loading-button
            :handler="handleValidate"
            class="btn btn-success"
          >
            {{ isCreateForm ? 'Thêm mới' : 'Cập nhật' }}
          </loading-button>
        </div>
      </div>
    </div>

    <b-overlay :show="loading">
      <div class="container-fluid py-6">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <b-card no-body class="shadow-sm">
              <div class="card-body p-6">
                <medicine-form
                  ref="medicineForm"
                  v-model="form"
                  :medicine-groups="medicineGroups"
                />
              </div>
            </b-card>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import MedicineForm from './modal/MedicineForm.vue';

export default {
  name: 'MedicineEdit',
  components: {
    'medicine-form': MedicineForm,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    form_type: {
      type: String,
      default: 'edit',
    },
    itemData: {
      type: Object,
      default: null,
    },
    medicineGroups: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      form: {
        id: null,
        name: '',
        code: '',
        shortName: '',
        strength: '',
        unit: '',
        medicineGroupId: '',
        isMedicine: true,
        price: null,
        description: '',
        status: 0,
      },
    };
  },

  computed: {
    isCreateForm() {
      return !this.id;
    },
  },

  created() {
    if (this.itemData) {
      this.form = {
        id: this.itemData.id,
        name: this.itemData.name || '',
        code: this.itemData.code || '',
        shortName: this.itemData.shortName || '',
        strength: this.itemData.strength || '',
        unit: this.itemData.unit || '',
        medicineGroupId: this.itemData.medicineGroupId || '',
        isMedicine: this.itemData.isMedicine !== undefined ? this.itemData.isMedicine : true,
        price: this.itemData.price || null,
        medicineActiveIngredients: this.itemData.medicineActiveIngredients || [],
        bundleMedicineActiveIngredientsMapping: (this.itemData.medicineActiveIngredients || []).map((x) => x.activeIngredientId),
        description: this.itemData.description || '',
        status: this.itemData.status !== undefined ? this.itemData.status : 0,
      };
    } else {
      this.loadData();
    }
  },
watch: {
 
},
  methods: {
    async loadData() {
      if (!this.id) return;
      try {
        this.loading = true;
        const { data } = await this.$api.get(`BundleMedicine/${this.id}`);
        this.form = {
          id: data.id,
          name: data.name || '',
          code: data.code || '',
          shortName: data.shortName || '',
          strength: data.strength || '',
          unit: data.unit || '',
          medicineGroupId: data.medicineGroupId || '',
          isMedicine: data.isMedicine !== undefined ? data.isMedicine : true,
          price: data.price || null,
          description: data.description || '',
          medicineActiveIngredients: data.medicineActiveIngredients || [],
          bundleMedicineActiveIngredientsMapping: (data.medicineActiveIngredients || []).map((x) => x.activeIngredientId),
          status: data.status !== undefined ? data.status : 0,
        };
      } catch (error) {
        this.$toastr.e({ title: 'Lỗi!', msg: error });
        this.goBack();
      } finally {
        this.loading = false;
      }
    },

    async handleValidate() {
      let isValid = true;
      try {
        isValid = await this.$refs.medicineForm.validate();
      } catch (e) {
        console.error('Validate error:', e);
      }
      if (!isValid) {
        this.$toastr.e({ title: 'Lỗi!', msg: 'Vui lòng điền đầy đủ thông tin bắt buộc!' });
        return;
      }
      await this.submit();
    },

    async submit() {
      const payload = new FormData();
      payload.append('shortName', this.form.shortName || '');
      payload.append('name', this.form.name || '');
      payload.append('medicineGroupId', this.form.medicineGroupId || '');
      payload.append('isMedicine', this.form.isMedicine ? 'true' : 'false');
      payload.append('strength', this.form.strength || '');
      payload.append('unit', this.form.unit || '');
      payload.append('price', parseInt(this.form.price) || 0);
      payload.append('description', this.form.description || '');
      payload.append('status', parseInt(this.form.status) || 0);
      const activeIngredientIds = this.form.activeIngredientIds || [];
      const medicineActiveIngredients = activeIngredientIds.map((id) => ( id ));
      payload.append('bundleMedicineActiveIngredientsMapping', JSON.stringify(medicineActiveIngredients));
      payload.append('code', this.form.code || '');

      try {
        this.loading = true;
        if (this.isCreateForm) {
          await this.$api.post('BundleMedicine', payload);
          this.$toastr.s({ title: 'Thành công!', msg: 'Thêm mới thành công!' });
        } else {
          payload.append('id', this.form.id);
          await this.$api.put(`BundleMedicine/${this.form.id}`, payload);
          this.$toastr.s({ title: 'Thành công!', msg: 'Cập nhật thành công!' });
        }
        this.goBack();
      } catch (error) {
        this.$toastr.e({ title: 'Lỗi!', msg: error });
      } finally {
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: 'services_products' });
    },
  },
};
</script>

<style scoped lang="scss">
.medicine-edit-page {
  background-color: #f8f9fa;
  min-height: 100vh;
}
</style>